<script lang="ts">
  import type { Addon } from "../../helpers/types";
  import Card from "../atoms/Card.svelte";
  import Checkbox from "../atoms/Checkbox.svelte";
  import Heading from "../atoms/Heading.svelte";
  import InfoButton from "./InfoButton.svelte";

  interface Props {
    addons: Addon[];
    toggleAddonProduct: (id: number) => void;
    selectedAddons: number[];
  }

  let { addons, toggleAddonProduct, selectedAddons }: Props = $props();

  addons.forEach((addon) => {
    if (addon.preSelected) {
      toggleAddonProduct(addon.id);
    }
  });
</script>

<Card>
  <Heading variant="primary">Tillval</Heading>
  <div class="mt-4">
    {#each addons as addon}
      <div class="mb-2 relative flex items-center">
        <Checkbox
          onChange={() => toggleAddonProduct(addon.id)}
          checked={selectedAddons.includes(addon.id)}
          disabled={addon.mandatory}
        >
          {addon.name}
          :
          {#if addon.costs.kwhCost}
            {addon.costs.kwhCost} öre/kWh
          {/if}
        </Checkbox>
        <InfoButton iconSize={22} class="text-PurplePrimary">{addon.description}</InfoButton>
      </div>
    {/each}
  </div>
</Card>
